import Bridge from './bridge'
import { Toast } from 'vant'
export default {
  install (Vue) {
    const bridge = new Bridge()

    bridge.on('error', error => {
      const msg = `${error.type}: ${error.error.toString()}`
      console.error(msg) // eslint-disable-line
      Toast(error)
    })

    Vue.$rrcBridge = bridge
    Vue.mixin({
      created () {
        this.$rrcBridge = bridge
      }
    })
  }
}
